exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2xVvzGQ2Xq599y4T_95V6H{position:relative;top:50%;height:0;z-index:100}._3LckIMiCsMT2bgxyuBPacu{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;width:100%;height:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);
// Exports
exports.locals = {
	"pageLoading": "_2xVvzGQ2Xq599y4T_95V6H",
	"mainContent": "_3LckIMiCsMT2bgxyuBPacu"
};